import React from 'react'

function Home() {
  return <div>
    <h2>Slides</h2>
    <p>Navigate the non-Google slides with the arrows in the corner or the arrow keys on your keyboard</p>
    <ul>
      <li><a href='/slides/intro.html'>Intro/Journalism</a></li>
      <li><a href='/slides/html.html'>HTML</a></li>
      <li><a href='/slides/css.html'>CSS</a></li>
      <li><a href='https://docs.google.com/presentation/d/1sjXNHiMxkigvD12SvLz6XNOe89u5Y4BbFOCHJoAaK_M/edit?usp=sharing'>Git</a></li>
      <li><a href='https://docs.google.com/presentation/d/1iOlrF8uuqd06nXTuriemlNTDcuYkdnNVvwmXkSNNiPU/edit?usp=sharing'>React</a></li>
      <li><a href='https://docs.google.com/presentation/d/1wAgQ8YmcqFo9qwysK-m-5lZ8Dcikn32vo0ouuObMRxs/edit?usp=sharing'>REST APIs</a></li>
    </ul>
    <h2>Etc</h2>
    <p><a href='https://docs.google.com/forms/d/e/1FAIpQLSccP1hRTzmNQJPm2AQScVdfT1zTXI6dV_cDKQYG4LGNuwFxPA/viewform'>Pre-survey!</a></p>
    <p>Contact info: byronlutz@gmail.com</p>
  </div>
}

export default Home
